import { css } from '@emotion/core'
import React from 'react'

import { ctaInlineBreakPoint } from '../../constants/breakPoints'
import { breakpoints } from '../../constants/breakPoints'
import { isMobile } from '../../helpers/common'
import { Button } from '../Button'
import Image from '../Image'
import { blueTextStyle } from './CTANewsletter'

const CTAProductWalkthrough = () => {
  return (
    <div className="purple-bg with-box-shadow" css={containerStyle}>
      <div css={contentStyle}>
        <div className="heading4 blue-text" css={blueTextStyle}>
          Product Walkthrough
        </div>
        <h2 className="heading2 black-text no-margin">
          See airfocus <br /> in action
        </h2>
        <Button link="/cta/inline/resources/events/learn-airfocus/index/" css={buttonStyle}>
          Sign up
        </Button>
      </div>
      <div css={imageStyle}>
        <Image
          src={`cta/product-walkthrough${isMobile(breakpoints.small) ? '-small' : ''}.webp`}
          alt="airfocus live training"
        />
      </div>
    </div>
  )
}

export default CTAProductWalkthrough

const containerStyle = css`
  margin: 2rem 0;
  border-radius: 0.5rem;
  position: relative;

  @media screen and (max-width: ${breakpoints.small}px) {
    margin-top: 3rem;
  }
`

const contentStyle = css`
  padding: 3rem 0 3rem 3rem;

  @media screen and (max-width: ${breakpoints.xlarge}px) {
    padding: 2rem 0 2rem 3rem;
  }

  @media screen and (max-width: ${ctaInlineBreakPoint}px) and (min-width: ${breakpoints.medium + 1}px) {
    padding: 2rem 0 2rem 2.5rem;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    padding: 2rem;
  }
`

const buttonStyle = css`
  margin-top: 1.5rem;
`

const imageStyle = css`
  position: absolute;
  width: 45%;
  right: 3%;
  top: 50%;
  transform: translateY(-45%);

  @media screen and (max-width: ${breakpoints.medium}px) {
    width: 40%;
    right: 3%;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    width: 75px;
    top: 0;
    right: 1rem;
  }
`
